import { formatUnits } from 'viem'

import type { RewardsClaimSource } from '../events'
import { trackAnalyticsEvent } from '../track'

interface RewardsClaimClickedParams {
  source: RewardsClaimSource
  /**
   * `undefined` when the displayed amount doesn't belong to the wallet the CTA
   * opens Merkl for — i.e. while viewing someone else's portfolio. Omitted
   * rather than sent as 0, which would drag the average conversion value down.
   */
  claimableUsdRaw: bigint | undefined
}

/**
 * Fired when a user clicks a "Claim" CTA, which redirects off-app to the Merkl
 * dashboard — so this click is the only signal we get for the rewards-claim
 * conversion. Every CTA hits the same Merkl URL, hence `source` to tell the
 * three surfaces apart.
 */
export function trackRewardsClaimClicked({ source, claimableUsdRaw }: RewardsClaimClickedParams) {
  trackAnalyticsEvent('rewards_claim_clicked', {
    source,
    ...(claimableUsdRaw !== undefined && {
      claimable_usd: Number(formatUnits(claimableUsdRaw, 18))
    })
  })
}
